// extracted by mini-css-extract-plugin
export default {"statusError":"StatusTableCellValue_statusError__eGvs7","statusOk":"StatusTableCellValue_statusOk__aEfd6","root":"StatusTableCellValue_root__c4UES"};